import logger from 'logger';
import { call, put } from 'store/utils';
import { authConferenceUser } from 'utils/apiCalls';
import * as userActions from './userActions';

// Example Token
// {
//   sessionId: 'cb0c82a1-ddbf-415f-a9d2-dcdd18594e3d',
//   sessionName: 'test session cb0c82a1-ddbf-415f-a9d2-dcdd18594e3d',
//   userEmail: 'scott@continuoussoftware.com',
//   userId: '1',
//   userFirstName: 'Scott',
//   userLastName: 'altman',
//   userRole: 'attendee', attendee || admin || presenter
// }
export function* authorizeToken(token) {
  const authData = yield call(authConferenceUser, token);
  logger.info('response from authConference:', authData);
  const { user, tokenData } = authData;
  yield put(
    userActions.setUserAction({
      email: user.Email,
      userId: user.UserId,
      cmsId: user.CmsId,
      admin: user.Admin,
      firstName: user.FirstName,
      lastName: user.LastName,
      role: tokenData.userRole,
    })
  );

  return authData;
}
